import { useMobilePlatform } from "core/hooks/useMobilePlatform";

declare global {
  interface Window {
    interdeal: any;
  }
}

export const EqualWebButton = () => {
  const { isMobileApp } = useMobilePlatform();

  if (isMobileApp) {
    return null;
  }

  return (
    <button onClick={() => window.interdeal?.a11y.openMenu()} className="h-full mx-2">
      <img src="https://cdn.equalweb.com/assets/images/1.svg" alt="Web Equal" className="h-7 w-7" />
    </button>
  );
};
